import Highcharts from 'highcharts';
import SolidGauge from 'highcharts/modules/solid-gauge';
import { abbrNumber } from 'utils/chart';
import { getTheme } from 'utils/themes';
import BaseChartMore from '../baseChartMore';

SolidGauge(Highcharts);

// type Props = {
//   /** An additional class. */
//   className: ?string,
//   /* Numerator Value */
//   numerator: number,
//   /* Denominator Value */
//   denominator: number,
//   /* Set additional options for radial chart. */
//   options: {},
//   /* Theme of the radial chart. */
//   theme: string,
// };

const defaultProps = {
  theme: 'default',
};

export default function Radial(props) {
  const { className, numerator, denominator, options, theme, ...otherProps } = props;
  const themeDef = getTheme(theme);

  const fraction = numerator / denominator;
  const maxValue = 100;
  const percent = Math.floor(fraction * maxValue);

  const defaultOptions = {
    tooltip: {
      enabled: false,
    },
    pane: {
      startAngle: 0,
      endAngle: 360,
      background: [
        {
          outerRadius: '110%',
          innerRadius: '88%',
          backgroundColor: themeDef.radialBackground,
          borderWidth: 0,
        },
      ],
    },
    yAxis: {
      min: 0,
      max: 100,
      lineWidth: 0,
      tickPositions: [],
    },

    plotOptions: {
      solidgauge: {
        dataLabels: {
          y: -30,
          x: 2,
          borderWidth: 0,
          useHTML: true,
        },
        linecap: 'round',
        stickyTracking: false,
        rounded: true,
      },
      series: {
        color: 'purple',
        radius: '110%',
        innerRadius: '88%',
        dataLabels: {
          format: `<div style="text-align:center"><span style="font-size:30px;color:${
            themeDef.textColor
          };">${percent}%</span><div style="color:${themeDef.textColor};">${abbrNumber(
            numerator,
          )} / ${abbrNumber(denominator)}</div>`,
        },
      },
    },
  };

  const data = [
    {
      data: [
        {
          y: percent,
        },
      ],
    },
  ];

  return (
    <BaseChartMore
      className={className}
      chartType="solidgauge"
      defaultOptions={defaultOptions}
      data={data}
      options={options}
      theme={theme}
      {...otherProps}
    />
  );
}

Radial.defaultProps = defaultProps;
